import {
  AfterViewInit,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output, SimpleChanges,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { AsyncPipe, CommonModule, JsonPipe } from "@angular/common";
import {FlexModule} from "@angular/flex-layout/flex";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {
  ApplicationDialogService,
  applicationToAbnAgeAboveThreshold,
  applicationToAdverseOnFile,
  applicationToAsset,
  applicationToAssetCondition, applicationToBalloonPayment,
  applicationToBalloonPaymentPrecentage,
  applicationToBalloonPaymentPrecentageNumber,
  applicationToBrokerageAmount,
  applicationToBrokerOriginationFee,
  applicationToBusinessSearchValue,
  applicationToCrediRateAdjustment,
  applicationToDepositAmount, applicationToDocFee,
  applicationToDocFeeFinanced,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  applicationToFinanceType,
  applicationToInvoiceAmount,
  applicationToLastUpdatedByUser,
  applicationToLoanAmount,
  applicationToLoanTerms,
  applicationToLoanTermsValue,
  applicationToPaymentFrequency,
  applicationToPropertyOwner,
  applicationToTransactionValue,
  ASSET_FINANCE_OPTIONS_FILTER,
  AssetSelectionComponentSearchFn,
  createTwoDecimalInputMask,
  getUser,
  linkEquifaxDirectorScoreControls,
  PortalHotToastService
} from "@portal-workspace/grow-ui-library";
import {PercentagePipe} from '../../../pipes/percentage.pipe';
import {DisableControlDirective} from '../../../directives/disable-control.directive';
import { AssetConditionComponent } from '../../asset-cat-and-type-component/asset-condition.component';
import { AssetSelectionComponent, AssetSelectionComponentEvent } from '../../asset-cat-and-type-component/asset-selection.component';
import { CurrencyInputComponent } from '../../currency-selection-component/currency-input.component';
import { BalloonPaymentComponent } from '../../balloon-payment-component/balloon-payment.component';
import { BrokerageSelectionComponent } from '../../brokerage-component/brokerage-selection.component';
import { FinanceTypeSelectionComponent } from '../../finance-type-component/finance-type-selection.component';
import { LoanTermsSelectionComponent } from '../../loan-terms-selection-component/loan-terms-selection.component';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { PaymentFrequencySelectionComponent } from '../../payment-frequency-selection-component/payment-frequency-selection.component';
import { TransactionTypeSelectionComponent } from '../../transaction-type-selection-component/transaction-type-selection.component';
import { YesNoComponent } from '../../yes-no-component/yes-no.component';
import { PercentageInputComponent } from '../../percentage-input-component/percentage-input.component';
import {MatInputModule} from "@angular/material/input";
import {InputMaskModule} from "@ngneat/input-mask";
import {LooseCurrencyPipe} from '../../../pipes/loose-currency.pipe';
import {MarkDirective} from '../../../directives/mark-as-dirty.directive';
import {
  AppCalculator,
  AssetConditionValue,
  AssetFinanceApplication,
  AssetSelectionComponentValue,
  BalloonPaymentValue,
  BalloonPaymentValueOptions,
  booleanToYesNo,
  BrokerageSelectionValue,
  assetFinanceEquifaxDirectorScoreThreshold,
  calculateAssetFinanceEstimation,
  CalculateAssetFinanceEstmationResult,
  CurrencyInputValue,
  FinanceTypeValue,
  getBrokerage,
  getInterestRate,
  GetRateCardDetailsFn,
  isAdmin,
  isCreditUser,
  PaymentFrequencyValue,
  RatecardDetails,
  TermRate,
  TotalPaymentBreakupDialogData,
  TransactionValue,
  UpdateApplicationData,
  UpdateApplicationFn,
  UpdateApplicationSfFn,
  YesNoValue,
  isAdminOrCreditUserOrSalesAM,
  isInternalUser,
  PrivateSaleType,
  getRepayment,
  GetContractStatusFn,
  isAdminOrCreditUser,
  isAdminOrCreditOrOperationsOrSalesUser,
  BrokerageSelectionType,
  isAssetVehicles,
  isAssetNewCars,
  isAssetTrucksOrTrailers,
  isAssetTypeLightOrHeavyTruck,
  LoanTermsSelectionWithInputValue,
  getRepaymentType,
  GetOriginatorBusinessByIdFn,
  TransactionValueOptions, minDepositForPricingAssetFinance,
  getMaxLoanTermForTier,
  ASSET_FINANCE_MAX_BROKERAGE_PERCENT,
  ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT,
  getTreasuryAssetCondition,
  isTransactionTypeAllowedForNewAsset,
  getAllowedTransactionTypesForNewAsset,
} from '@portal-workspace/grow-shared-library';
import {loadingFor} from "@ngneat/loadoff";
import {UntilDestroy} from "@ngneat/until-destroy";
import {combineLatest, Subject, Subscription} from "rxjs";
import {pairwise, tap} from "rxjs/operators";
import _ from "lodash";
import moment, {Moment} from "moment/moment";
import numeral from "numeral";
import { MatTableModule} from "@angular/material/table";
import { MatCardModule } from '@angular/material/card';
import { LoanTermsSelectionWithInputComponent } from '../../loan-terms-selection-component/loan-terms-selection-with-input.component';

export type AssetPricingComponentEvent = AssetPricingComponentSavedEvent;
const DEALER_SALE_TRANSACTION_TYPE = TransactionValueOptions.find(opt => opt.type == 'Dealer Sale');
export interface AssetPricingComponentSavedEvent {
  type: 'asset-pricing-saved',
  rst: CalculateAssetFinanceEstmationResult,
  balloonPercentageDecreased?: boolean,
}

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
  selector: 'asset-pricing',
  templateUrl: './asset-pricing.component.html',
  styleUrls: ['./asset-pricing.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexModule,
    MatButtonModule,
    MatFormFieldModule,
    AsyncPipe,
    JsonPipe,
    AssetConditionComponent,
    AssetSelectionComponent,
    BalloonPaymentComponent,
    BrokerageSelectionComponent,
    CurrencyInputComponent,
    FinanceTypeSelectionComponent,
    LoanTermsSelectionComponent,
    PaymentFrequencySelectionComponent,
    TransactionTypeSelectionComponent,
    YesNoComponent,
    MessageBoxComponent,
    DisableControlDirective,
    MatInputModule,
    InputMaskModule,
    MatTableModule,
    MatCardModule,
    PercentageInputComponent,
    LooseCurrencyPipe,
    PercentagePipe,
    MarkDirective,
    LoanTermsSelectionWithInputComponent,
]
})
export class AssetPricingComponent implements OnInit, AfterViewInit {

  // Helper method for template
  parseAssetYear(year: string | null | undefined): number | null {
    return year ? parseInt(year) : null;
  }
  
  markSubject = new Subject<boolean>();

  MIN_ORIGINATION_FEE = 0;
  MAX_ORIGINATION_FEE = 900;

  @Input({required: true}) assetSearchFn!: AssetSelectionComponentSearchFn;
  @Input({required: true}) getRateCardDetailsFn!: GetRateCardDetailsFn;
  @Input({required: true}) updateApplicationFn!: UpdateApplicationFn;
  @Input({required: true}) updateApplicationSfFn!: UpdateApplicationSfFn;
  @Input({required: true}) getContractStatusFn!: GetContractStatusFn;
  @Input({required: true}) application!: AssetFinanceApplication;
  @Input({required:true}) currentRstValue!: TotalPaymentBreakupDialogData;
  @Output() events = new EventEmitter<AssetPricingComponentEvent>();
  @Input({required: true}) getOriginatorBusinessByIdFn!: GetOriginatorBusinessByIdFn;
  @ViewChild('balloonPaymentComponent') balloonPaymentComponent!: BalloonPaymentComponent;

  dataSource: (
    {name: string, highlight?: (value: string | null | undefined) => boolean, type: 'text', value: string | null | undefined} |
    {name: string, highlight?: (value: number | string | null | undefined) => boolean, type: 'currency', value: number | string | null | undefined} |
    {name: string, highlight?: (value: number | string | null | undefined)=>boolean, type: 'percentage', value: number | string | null | undefined}
  )[] = [];

  currentTemplate: TemplateRef<any> | null = null;

  @ViewChild('readMode') readModeTemplate!: TemplateRef<any>;
  @ViewChild('editMode') editModeTemplate!: TemplateRef<any>;

  subscriptions: Subscription[] = [];

  formBuilder: FormBuilder = inject(FormBuilder);
  applicationDialogService: ApplicationDialogService = inject(ApplicationDialogService);
  toastService: PortalHotToastService = inject(PortalHotToastService);

  loader = loadingFor('saveRate');

  // credit adjustment
  ADMIN_MIN_CREDIT_RATE = -10000;
  ADMIN_MAX_CREDIT_RATE = 10000;
  CREDIT_MIN_CREDIT_RATE = -5;
  CREDIT_MAX_CREDIT_RATE = 5;
  NON_CREDIT_OR_ADMIN_MIN_CREDIT_RATE = -1;
  NON_CREDIT_OR_ADMIN_MAX_CREDIT_RATE = 5;
  MIN_CREDIT_RATE = this.ADMIN_MIN_CREDIT_RATE;
  MAX_CREDIT_RATE = this.ADMIN_MAX_CREDIT_RATE;

  MIN_LOAN_AMOUNT = 0.01;
  ASSET_FINANCE_OPTIONS_FILTER = ASSET_FINANCE_OPTIONS_FILTER;
  ASSET_FINANCE_MAX_BROKERAGE_PERCENT = ASSET_FINANCE_MAX_BROKERAGE_PERCENT;
  ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT = ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT;

  user = getUser();
  isInternalUser = isInternalUser(this.user)
  isAdminOrCreditUserOrSalesAM = isAdminOrCreditUserOrSalesAM(this.user);
  canEditPricingByRole = isAdminOrCreditOrOperationsOrSalesUser(this.user);
  isNotAdminOrCreditUser = !isAdminOrCreditUser(this.user);
  isAdminOrCreditUser = isAdminOrCreditUser(this.user);
  isCreditUser = isCreditUser(this.user);
  isAdmin = isAdmin(this.user);
  isDealer : boolean =false
  isContractPending: boolean = true; // if a contract is pending for this application
  isApplicationStagePostQa = true;
  lastEditedByUser ?: string | null

  createTwoDecimalInputMask = createTwoDecimalInputMask();

  assetSelectionReady = false;

  rateCard: RatecardDetails | null = null;
  AmountFinance!: number;
  data: Partial<UpdateApplicationData> | null = null;  // available after chart popups (after onGenerateQuote())
  terms: TermRate | null = null;              // available after chart popups (after onGenerateQuote())
  calculator: AppCalculator | null = null;    // available after chart popups (after onGenerateQuote())
  rst: CalculateAssetFinanceEstmationResult | null = null;                            // calculate estimation result (available after chart popups (after onGenerateQuote())
  brokeragePercentage!: number;

  formGroupStep2!: FormGroup<{
    invoiceAmount: FormControl<CurrencyInputValue>,
    depositAmount: FormControl<CurrencyInputValue>,
    loanAmount: FormControl<CurrencyInputValue>,
    asset: FormControl<AssetSelectionComponentValue>,
    assetCondition: FormControl<AssetConditionValue>,
    loanTerms: FormControl<LoanTermsSelectionWithInputValue>,
    paymentFrequency: FormControl<PaymentFrequencyValue>,
    financeType: FormControl<FinanceTypeValue>,
    docFeeFinanced: FormControl<YesNoValue>,
    balloonPayment: FormControl<BalloonPaymentValue>,
    brokerOriginationFee: FormControl<CurrencyInputValue>,
    brokerageAmount: FormControl<CurrencyInputValue>,
    propertyOwner: FormControl<YesNoValue>,
    adverseOnFile: FormControl<YesNoValue>,
    equifaxScoreAboveThreshold: FormControl<YesNoValue>,
    equifaxDirectorScoreAbove700: FormControl<YesNoValue>,
    transactionType: FormControl<TransactionValue>,
    abnGstAgeAboveThreshold: FormControl<YesNoValue>,
    creditRateAdjustment: FormControl<number | null>,
  }>;
  step2AssetCategoryIndexFilter = ['130', '137', '132', '133', '134', '135', '136', '106', '140', '142'];
  step2MinBrokerOriginationFee = this.MIN_ORIGINATION_FEE ;
  step2MaxBrokerOriginationFee = this.MAX_ORIGINATION_FEE ;
  step2MinBrokerageAmount: number = 0;
  step2MaxBrokerageAmount: number = 999999;
  step2DepositMin: number | null = null;
  step2DepositMax: number | null = null;
  step2InvoiceAmountMin: number = this.MIN_LOAN_AMOUNT;
  step2InvoiceAmountMax: number | null = null;
  step2Repayment = 0;
  step2EstimatedDrawdownDate: Moment = moment();
  step2MaxBalloonPercentage: number  = 50;
  step2MaxLoanTerm: number = 84;
  formControlStep2InvoiceAmount!: FormControl<CurrencyInputValue>;
  formControlStep2DepositAmount!: FormControl<CurrencyInputValue>;
  formControlStep2LoanAmount!: FormControl<CurrencyInputValue>;
  formControlStep2Asset!: FormControl<AssetSelectionComponentValue>;
  formControlStep2AssetCondition!: FormControl<AssetConditionValue>;
  formControlStep2LoanTerms!: FormControl<LoanTermsSelectionWithInputValue>;
  formControlStep2PaymentFrequency!: FormControl<PaymentFrequencyValue>;
  formControlStep2FinanceType!: FormControl<FinanceTypeValue>;
  formControlStep2DocFeeFinanced!: FormControl<YesNoValue>;
  formControlStep2BalloonPayment!: FormControl<BalloonPaymentValue>;
  formControlStep2BrokerOriginationFee!: FormControl<CurrencyInputValue>;
  formControlStep2BrokerageAmount!: FormControl<CurrencyInputValue>;
  formControlStep2TransactionType!: FormControl<TransactionValue>;
  formControlStep2PropertyOwner!: FormControl<YesNoValue>;
  formControlStep2AdverseOnFile!: FormControl<YesNoValue>;
  formControlStep2EquifaxScoreAboveThreshold!: FormControl<YesNoValue>;
  formControlStep2EquifaxDirectorScoreAbove700!: FormControl<YesNoValue>;
  formControlAbnAgeAboveThreshold!: FormControl<YesNoValue>;
  formControlCreditRateAdjustment!: FormControl<number | null>

  ngOnInit() {
    this.formControlStep2InvoiceAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DepositAmount = this.formBuilder.control(0, [Validators.required]);
    this.formControlStep2LoanAmount = this.formBuilder.control(null, [Validators.required ]);
    this.formControlStep2Asset = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2AssetCondition = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2LoanTerms = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2PaymentFrequency = this.formBuilder.control( { type: 'Monthly', name: 'Monthly'}, [Validators.required]);
    this.formControlStep2FinanceType = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2DocFeeFinanced = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2BalloonPayment = this.formBuilder.control(BalloonPaymentValueOptions[0], [Validators.required]);
    this.formControlStep2BrokerOriginationFee = this.formBuilder.control(0, [Validators.required]);
    this.formControlStep2BrokerageAmount = this.formBuilder.control(null, [Validators.required]);
    this.formControlStep2PropertyOwner = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2AdverseOnFile = this.formBuilder.control(false, [Validators.required]);
    this.formControlStep2EquifaxScoreAboveThreshold = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2EquifaxDirectorScoreAbove700 = this.formBuilder.control(true, [Validators.required]);
    this.formControlStep2TransactionType = this.formBuilder.control(null, [Validators.required]);
    this.formControlAbnAgeAboveThreshold = this.formBuilder.control(true, [Validators.required]);
    this.formControlCreditRateAdjustment = this.formBuilder.control(0.0, [Validators.required]);

    this.formGroupStep2 = this.formBuilder.group({
      invoiceAmount: this.formControlStep2InvoiceAmount,
      depositAmount: this.formControlStep2DepositAmount,
      loanAmount: this.formControlStep2LoanAmount,
      asset: this.formControlStep2Asset,
      assetCondition: this.formControlStep2AssetCondition,
      loanTerms: this.formControlStep2LoanTerms,
      paymentFrequency: this.formControlStep2PaymentFrequency,
      financeType: this.formControlStep2FinanceType,
      docFeeFinanced: this.formControlStep2DocFeeFinanced,
      balloonPayment: this.formControlStep2BalloonPayment,
      brokerOriginationFee: this.formControlStep2BrokerOriginationFee,
      brokerageAmount: this.formControlStep2BrokerageAmount,
      propertyOwner: this.formControlStep2PropertyOwner,
      adverseOnFile: this.formControlStep2AdverseOnFile,
      equifaxScoreAboveThreshold: this.formControlStep2EquifaxScoreAboveThreshold,
      equifaxDirectorScoreAbove700: this.formControlStep2EquifaxDirectorScoreAbove700,
      transactionType: this.formControlStep2TransactionType,
      abnGstAgeAboveThreshold: this.formControlAbnAgeAboveThreshold,
      creditRateAdjustment: this.formControlCreditRateAdjustment,
    });

    this.subscriptions.push(...linkEquifaxDirectorScoreControls(
      this.formControlStep2EquifaxScoreAboveThreshold,
      this.formControlStep2EquifaxDirectorScoreAbove700,
      () => !this.isNotAdminOrCreditUser,
    ));

    // populate
    this.populate();

    this.createReadonlyTableDataSource();


    if (this.isNotAdminOrCreditUser) { // not credit or admin
      // cannot change risk profile
      this.formControlStep2PropertyOwner.disable();
      this.formControlStep2AdverseOnFile.disable();
      this.formControlStep2EquifaxScoreAboveThreshold.disable();
      this.formControlStep2EquifaxDirectorScoreAbove700.disable();

      // cannot change ABN GST Age
      this.formControlAbnAgeAboveThreshold.disable();

      // deposit restriction
      this.subscriptions.push(combineLatest([
        this.formControlStep2InvoiceAmount.valueChanges,
        this.formControlStep2PropertyOwner.valueChanges,
        this.formControlStep2Asset.valueChanges,
      ]).pipe(
        tap(vals => {
          const invoiceAmount = vals[0];
          const propertyOwner = vals[1];
          const assetSelection = vals[2];
          this.step2UpdateDepositValidation();
        })
      ).subscribe());

    } else { // credit or admin
      // no deposit restriction
      this.step2DepositMin = 0;
      this.step2DepositMax = applicationToInvoiceAmount(this.application);
      this.subscriptions.push(this.formControlStep2InvoiceAmount.valueChanges.pipe(
        tap(_invoiceAmount => {
          this.step2UpdateDepositValidation();
        })
      ).subscribe());
    }

    this.subscriptions.push(combineLatest([
      this.formControlStep2InvoiceAmount.valueChanges,
      this.formControlStep2DepositAmount.valueChanges,
      this.formControlStep2FinanceType.valueChanges,
    ]).pipe(
      tap(r => {
        const invoiceAmount = r[0] ?? 0;
        const depositAmount = r[1] ?? 0;
        const financeType = r[2];
        const depositAmountExGST = Math.round(depositAmount * 1000 / 11) / 100;
        const deposit = financeType?.type === 'rental' ? depositAmountExGST : depositAmount;
        const loanAmount = parseFloat((invoiceAmount - deposit > 0) ? (invoiceAmount - deposit).toFixed(2) : '0');
        this.formControlStep2LoanAmount.setValue(loanAmount);
        // Re-cap the balloon so its amount can't exceed the new loan amount (invoice - deposit)
        this.step2UpdateMaxBalloonPercentage();
        this.formControlStep2BrokerageAmount.setValue(loanAmount * this.brokeragePercentage / 100);
        this.step2MaxBrokerageAmount = Math.round(loanAmount * ASSET_FINANCE_MAX_BROKERAGE_PERCENT) / 100;
      })
    ).subscribe());

    this.subscriptions.push(this.getRateCardDetailsFn(this.application.UserId, 'AssetFinance').pipe(
      tap(rateCardDetails => {
        this.rateCard = rateCardDetails;
      })
    ).subscribe());

    // get contract status for application
    this.subscriptions.push(this.getContractStatusFn(this.application.ApplicationId).pipe(
      tap(r => {
        const {contractPending} = r.signers.reduce((acc, signer) => {
          const contractPending = ["created", "sent", "delivered", "signed", "completed", "faxpending"].includes(signer.status);
          acc.contractPending = acc.contractPending || contractPending;
          return acc;
        }, { contractPending: false});
        this.isContractPending = contractPending;
      })
    ).subscribe());

    this.isApplicationStagePostQa = ['QA', 'Settlement', 'Closed Lost', 'Closed Lost'].includes(this.application.InteflowStatusStageName ?? '');


    // balloon payment changes for rental application or loan term > 60 months
    // Credit Policy: Residual Values/Balloons are not allowed on applications with:
    // - Finance Type = Rental
    // - Loan term > 60 months (7 year terms)
    this.subscriptions.push(
      combineLatest([
        this.formControlStep2InvoiceAmount.valueChanges,
        this.formControlStep2FinanceType.valueChanges,
        this.formControlStep2LoanTerms.valueChanges
      ]).pipe(
      tap(() => {
        this.step2UpdateMaxBalloonPercentage();
      })
    ).subscribe())

    // pop up rental excl gst notification
    this.subscriptions.push(
      this.formControlStep2FinanceType.valueChanges.pipe(
        pairwise()
      ).subscribe(
        ([prev, financeType]: [FinanceTypeValue | null, FinanceTypeValue | null]) => {
          if (prev && prev.type !== financeType?.type) {
            if (financeType?.type === 'rental') {
              this.formControlStep2PaymentFrequency.disable();
              this.formControlStep2PaymentFrequency.setValue( { type: 'Monthly', name: 'Monthly'}/*monthly*/);
            } else if (financeType?.type === 'chattel-mortgage') {
              this.formControlStep2PaymentFrequency.enable();
            }
          }
        }
      )
    )
    if(this.formControlStep2FinanceType.value?.type === 'chattel-mortgage'){
      this.formControlStep2PaymentFrequency.enable();
    }else{
      this.formControlStep2PaymentFrequency.disable();
      this.formControlStep2PaymentFrequency.setValue( { type: 'Monthly', name: 'Monthly'}/*monthly*/);
    }
    // Initial state: cap balloon for rental / long term / loan amount
    this.step2UpdateMaxBalloonPercentage();
    if (this.application.OriginatorBusinessId) {
    this.subscriptions.push(
      this.getOriginatorBusinessByIdFn(this.application.OriginatorBusinessId).subscribe(originatorBusiness => {
        if (originatorBusiness) {
          this.isDealer = originatorBusiness?.Type === 'dealer' ? true : false;
        }
      })
    );
    }
  }

  populate() {
    this.formControlStep2InvoiceAmount.setValue(applicationToInvoiceAmount(this.application));
    this.formControlStep2DepositAmount.setValue(applicationToDepositAmount(this.application));
    this.formControlStep2LoanAmount.setValue(applicationToLoanAmount(this.application));
    this.formControlStep2Asset.setValue(applicationToAsset(this.application));
    this.formControlStep2AssetCondition.setValue(applicationToAssetCondition(this.application));
    this.formControlStep2LoanTerms.setValue(applicationToLoanTermsValue(this.application));
    this.formControlStep2PaymentFrequency.setValue(applicationToPaymentFrequency(this.application));
    this.formControlStep2FinanceType.setValue(applicationToFinanceType(this.application));
    this.formControlStep2DocFeeFinanced.setValue(applicationToDocFeeFinanced(this.application));
    this.formControlStep2BalloonPayment.setValue(applicationToBalloonPaymentPrecentage(this.application));
    this.formControlStep2BrokerOriginationFee.setValue(applicationToBrokerOriginationFee(this.application));
    this.formControlStep2PropertyOwner.setValue(applicationToPropertyOwner(this.application));
    this.formControlStep2AdverseOnFile.setValue(applicationToAdverseOnFile(this.application));
    this.formControlStep2EquifaxScoreAboveThreshold.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=550'));
    this.formControlStep2EquifaxDirectorScoreAbove700.setValue(applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700'));
    if(this.isDealer && DEALER_SALE_TRANSACTION_TYPE){
      this.formControlStep2TransactionType.setValue({...DEALER_SALE_TRANSACTION_TYPE});
    }else{
      this.formControlStep2TransactionType.setValue(applicationToTransactionValue(this.application));
  }
    this.formControlAbnAgeAboveThreshold.setValue(applicationToAbnAgeAboveThreshold(this.application));
    this.formControlCreditRateAdjustment.setValue(applicationToCrediRateAdjustment(this.application));
    const calculator = new AppCalculator();
    const brokerageAmount = applicationToBrokerageAmount(this.application) == null ?
    calculator.calculateBrokerageAmount(applicationToLoanAmount(this.application) ?? 0, getBrokerage(this.application)):
    applicationToBrokerageAmount(this.application);
    this.formControlStep2BrokerageAmount.setValue(brokerageAmount);
    this.brokeragePercentage = getBrokerage(this.application);
  }

  createReadonlyTableDataSource() {
    this.lastEditedByUser = applicationToLastUpdatedByUser(this.application)?.name

    const asset = applicationToAsset(this.application);
    const calculator = new AppCalculator();

    const baseDataSource: typeof this.dataSource = [
      { name: 'Invoice Amount ($)', type: 'currency', value: applicationToInvoiceAmount(this.application)},
      { name: 'Asset Category', type: 'text', value: asset?.category?.value},
      { name: 'Asset Type', type: 'text', value: asset?.type?.value},
      { name: 'Asset Make', type: 'text', value: asset?.make ?? 'N/A' },
      { name: 'Asset Year', type: 'text', value: asset?.year },
      { name: 'Asset Description', type: 'text',  value: asset?.description},
      { name: 'Asset Condition', type: 'text', value: applicationToAssetCondition(this.application)?.type},
      { name: 'Loan Terms', type: 'text', value: `${applicationToLoanTerms(this.application)?.type ?? ''} months`},
      { name: 'Payment Frequency', type: 'text', value: applicationToPaymentFrequency(this.application)?.type },
      { name: 'Repayment Amount ($)', type: 'currency', value: getRepayment(this.application)},
      { name: 'Finance Type', type: 'text', value: applicationToFinanceType(this.application)?.name},
      { name: 'Property Owner', type: 'text', value: booleanToYesNo(applicationToPropertyOwner(this.application))},
      { name: 'Adverse on file', type: 'text', value: booleanToYesNo(applicationToAdverseOnFile(this.application))},
      { name: 'Director Equifax Score > 550', type: 'text', value: booleanToYesNo(applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=550'))},
      { name: 'Equifax Director Score above 700', type: 'text', value: booleanToYesNo(applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700'))},
      { name: 'Deposit Amount ($)', type: 'currency', value: applicationToDepositAmount(this.application)},
      { name: 'Loan Amount $)', type: 'currency', value: applicationToLoanAmount(this.application)},
      { name: 'Interest Rate (%)', type: 'percentage', value: getInterestRate(this.application)},
      { name: 'ABN age >= 24 months', type: 'text', value: booleanToYesNo(applicationToAbnAgeAboveThreshold(this.application)) },

      { name: 'Doc Fee Financed', type: 'text', value: booleanToYesNo(applicationToDocFeeFinanced(this.application))},
      { name: 'Doc Fee', type: 'currency', value: applicationToDocFee(this.application)},

      { name: 'Balloon Payment Due at maturity (%)', type: 'percentage', value: applicationToBalloonPaymentPrecentageNumber(this.application)},
      { name: 'Balloon Payment(Residual) ($)', type: 'currency', value: applicationToBalloonPayment(this.application)},

      { name: 'Broker Origination Fee (ex GST) ($)', type: 'currency', value: applicationToBrokerOriginationFee(this.application)},
      { name: 'Brokerage ($)', type: 'currency', value:
        applicationToBrokerageAmount(this.application) == null ?
        calculator.calculateBrokerageAmount(applicationToLoanAmount(this.application) ?? 0, getBrokerage(this.application)):
        applicationToBrokerageAmount(this.application)
      },

      { highlight: (v: any) => Number(v) != 0, name: 'Credit Rate Adjustment', type: 'percentage', value: applicationToCrediRateAdjustment(this.application) },
    ];

    this.dataSource = baseDataSource;
  }

  ngOnChanges(changes: SimpleChanges) {
    const change = changes['application'];
    if (change) {
      this.createReadonlyTableDataSource();
    }
  }

  ngAfterViewInit() {
    this.subscriptions.push(combineLatest([
      this.formControlStep2Asset.valueChanges,
      this.formControlStep2LoanTerms.valueChanges
    ]).pipe(
      tap((r: [AssetSelectionComponentValue, LoanTermsSelectionWithInputValue]) => {
        const assetSelectionValue = r[0];
        const loanTermValue = r[1];
        this.step2UpdateBalloonPaymentValidation(assetSelectionValue, loanTermValue);
      })
    ).subscribe());

    this.subscriptions.push(this.formControlStep2Asset.valueChanges.pipe(
      tap((r: AssetSelectionComponentValue) => {
        if (r && r.category && r.category.index) {
          this.step2MaxLoanTerm = getMaxLoanTermForTier(r.category.index);
        } else {
          this.step2MaxLoanTerm = 84;
        }
      })
    ).subscribe());

    if (this.application) {
      setTimeout(()=> {
        this.step2UpdateBalloonPaymentValidation(this.formControlStep2Asset.value, this.formControlStep2LoanTerms.value);
        const asset = this.formControlStep2Asset.value;
        if (asset && asset.category && asset.category.index) {
          this.step2MaxLoanTerm = getMaxLoanTermForTier(asset.category.index);
        }
      }, 2000);
    }
    this.currentTemplate = this.readModeTemplate;
  }

  step2UpdateBalloonPaymentValidation(_assetSelectionValue: AssetSelectionComponentValue, _loanTermValue: LoanTermsSelectionWithInputValue) {
    if (this.formControlStep2BalloonPayment.disabled) {
      this.step2MaxBalloonPercentage = 0;
      return;
    }
    this.step2MaxBalloonPercentage = 50;
    const currentBalloonPercentage = Number(this.formControlStep2BalloonPayment.value?.type ?? 0);
    if (currentBalloonPercentage > 50) {
      const maxBalloonOption = BalloonPaymentValueOptions.find((option) => option.type === '50');
      this.formControlStep2BalloonPayment.setValue(maxBalloonOption ?? BalloonPaymentValueOptions[0]);
    }
  }


  switchMode() {
    if (this.currentTemplate == this.editModeTemplate) {
      this.currentTemplate = this.readModeTemplate;
    } else {
      this.populate();
      this.currentTemplate = this.editModeTemplate;
    }
  }

  get matchBrokerageAmount() {
    return this.brokeragePercentage == _.round((this.formControlStep2BrokerageAmount.value ?? 0) * 100 / (this.formControlStep2LoanAmount.value ?? 0), 2);
  }


  /**
   * Returns the ABN age threshold override value:
   * - undefined: use actual ABN age from database (no override)
   * - true: treat as >= 24 months threshold (no ABN age penalty)
   * - false: treat as < 24 months threshold (apply ABN age penalty)
   */
  getAbnAgeAboveThresholdOverride(): boolean | undefined {
    const userSelectedAboveThreshold = this.formControlAbnAgeAboveThreshold.value;
    const originalAbnAge = this.application.CompanyDetails?.ABNAgeMonths ?? 0;
    const originalAboveThreshold = originalAbnAge >= 24;
    
    // Only return override if user has changed from the original value
    if (userSelectedAboveThreshold === originalAboveThreshold) {
      return undefined; // No override needed, use actual ABN age
    }
    
    return userSelectedAboveThreshold ?? undefined;
  }

  createApplicationData(){
    // NOTE: changes done here needs to be done in asset-finance.page.ts as well
    const asset = this.formControlStep2Asset.value;
    const loanTerm: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const loanAmount = _.round(this.formControlStep2LoanAmount.value ?? 0, 2);
    const invoiceAmount = this.formControlStep2InvoiceAmount.value;
    const deposit = this.formControlStep2DepositAmount.value;
    const brokerageAmount = this.formControlStep2BrokerageAmount.value;
    const brokeragePercentage = Math.round((brokerageAmount ?? 0) * 10000 / loanAmount) / 100;
    const brokerage: BrokerageSelectionValue = {type: `${brokeragePercentage}` as BrokerageSelectionType, name: `${brokeragePercentage}%`};
    const paymentPeriod: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const docFeeFinanced = this.formControlStep2DocFeeFinanced.value;
    const docFee = this.terms?.docFee ?? undefined;
    const brokerOriginationFee = this.formControlStep2BrokerOriginationFee.value;
    const propertyOwner = this.formControlStep2PropertyOwner.value;
    const adverseOnFile = this.formControlStep2AdverseOnFile.value;
    const equifaxScore = this.formControlStep2EquifaxScoreAboveThreshold.value;
    const rate = this.terms?.totalInterest ?? undefined;
    const balloonPercentage = Number(this.formControlStep2BalloonPayment.value?.type ?? 0);
    const balloonPayment = this.terms?.RV ?? 0;
    const assetCondition: AssetConditionValue = this.formControlStep2AssetCondition.value;
    const repayment = this.calculator?.emiAmt ?? undefined;
    const transactionType: TransactionValue = this.formControlStep2TransactionType.value;
    const financeType = this.formControlStep2FinanceType.value;
    const privateSales: PrivateSaleType = transactionType ? (
      transactionType.type === 'Dealer Sale' ? 'No' :
        (transactionType.type === 'Private Sale' ? 'Yes' : transactionType.type)
    ) : 'No';

    const apiBodyAppInfo: Partial<AssetFinanceApplication['AppInfo']> ={
      ...this.application.AppInfo,
      FinanceType: financeType?.name ?? undefined,
      AssetCategory: asset?.category.index ?? undefined,
      AssetType: asset?.type.index ?? undefined,
    }


    let apiBodyAssetSpec: UpdateApplicationData['AssetSpec'] = {
      make: asset?.make ?? undefined,
      family: asset?.family ?? undefined,
      year: asset?.year ?? undefined,
      vehicle: asset?.model ?? undefined,
      description: asset?.description ?? undefined,
      truckGrossVehicleWeight: asset?.truckGrossVehicleWeight ?? undefined,
      OtherCar: asset?.OtherCar ?? false,
      bodystyle: asset?.bodystyle ?? undefined,
    };


    // Keep original CompanyDetails without modifying ABN age
    // The ABN age threshold override is handled by the calculation via abnAgeAboveThresholdOverride parameter
    const companyDetails = this.application.CompanyDetails;


        // work out vehicle asset spec.
    let assetLvr = undefined;
    let vehSpec = {};
    if (asset && !asset.invalid) {
      if ((isAssetVehicles(asset.category.index) && isAssetNewCars(asset.category.index, asset.type.index)) ||
        (isAssetTrucksOrTrailers(asset.category.index) && isAssetTypeLightOrHeavyTruck(asset.category.index, asset.type.index))) {
        if(this.terms) {
          assetLvr = this.terms.LVR;
          vehSpec = asset.vehicle ?? {};
        }
        apiBodyAssetSpec = {
          ...apiBodyAssetSpec,
          ...vehSpec,
          LVR: assetLvr ?? undefined,
        };
      }
    }


    const apiBodyPricingDetails = {
      ...this.application.PricingDetails,
      LoanTerm: loanTerm ?? undefined,
      InvoiceAmount: (invoiceAmount != null ? (invoiceAmount) : undefined),
      Deposit: (deposit != null ? (deposit) : undefined),
      Brokerage: brokerage ? numeral(brokerage.type).value() ?? undefined : undefined,
      BrokerageAmount: this.terms?.brokerageAmount,
      LoanAmount: loanAmount,
      AmountFinance: this.AmountFinance,
      PaymentPeriod: paymentPeriod ? paymentPeriod.name : undefined,
      DocFee: (docFee != null ? Number(docFee) : undefined) ,
      DocFeeFinanced: booleanToYesNo(docFeeFinanced),
      BrokerOriginationFee: brokerOriginationFee ?? undefined,
      PropertyOwner: booleanToYesNo(propertyOwner),
      AdverseOnFile: booleanToYesNo(adverseOnFile),
      EquifaxDirectorScoreThreshold: assetFinanceEquifaxDirectorScoreThreshold(
        this.formControlStep2EquifaxDirectorScoreAbove700.value,
        equifaxScore,
      ),
      PremiumDiscount: this.terms?.premiumDiscount ?? 0,
      Rate: rate,
      BalloonPaymentPercentage: balloonPercentage,
      BalloonPayment: balloonPayment,
      Repayment: repayment,
      BankStatementSubmitted: 'No' as const,
      PrivateSale: privateSales,
      AssetCondition: assetCondition?.type ?? undefined,
      TreasuryAssetCondition: getTreasuryAssetCondition(asset?.year),
      TransactionType: transactionType ? transactionType.type : undefined,
      // Brokerage: this.terms?.brokerage,
      CreditRateAdjustment: Number(this.formControlCreditRateAdjustment.value),
      AbnAgeAboveThresholdOverride: this.getAbnAgeAboveThresholdOverride() === undefined
        ? null
        : booleanToYesNo(this.getAbnAgeAboveThresholdOverride())
    }

    const apiBody: Partial<UpdateApplicationData> = {
      UpdateApplicationIgnoreStatus: true,
      AppInfo: apiBodyAppInfo,
      AssetSpec: apiBodyAssetSpec,
      PricingDetails: apiBodyPricingDetails as any,
      CompanyDetails: companyDetails as any,
    }
    return apiBody;
  }

  save(confirmedBalloonDecrease = false) {
    const balloonPercentageDecreased = this.isBalloonPercentageDecreased();
    if (balloonPercentageDecreased && !confirmedBalloonDecrease) {
      this.subscriptions.push(
        this.applicationDialogService.openConfirmationDialog({
          message: 'Balloon % decreased',
          subMessage: 'Saving this change will move the application back to Submitted to Credit. Do you want to continue?'
        }).afterClosed().pipe(
          tap(result => {
            if (result?.readyForSubmission) {
              this.save(true);
            }
          })
        ).subscribe()
      );
      return;
    }
    if (this.rst) {
      this.subscriptions.push(this.updateApplicationSfFn(this.application.ApplicationId, this.data as UpdateApplicationData).pipe(
        this.toastService.spinnerObservable(),
        this.toastService.snackBarObservable(`Rate updated`),
        tap(r => {
          if(r.status){
            this.events.emit({
              type: "asset-pricing-saved",
              rst: this.rst!,
              balloonPercentageDecreased,
            });
            this.currentTemplate = this.readModeTemplate;
          }
        })
      ).subscribe());
    } else {
      this.applicationDialogService.openAlertDialog({
        message: 'Error',
        subMessage: `Cannot saved without performing calculation first`,
      });
    }
  }

  /**
   * This is how it works :-
   *  - calculateEstimation() which will
   *     - create terms from app-calculator
   *     - create data for sending to API for application data update
   *  - open up a pricing comparison dialog
   *  - when quotation is accepted in the comparison dialog
   *      - update the doc fee (if there are no changes the doc fee same value is returned
   *      - recreate the application data for submission
   */
  onGenerateQuote() {
    // A "New" asset can only be Dealer Sale, Internal Re-write or Sales and Lease Back
    const newAssetConditionValue = this.formControlStep2AssetCondition.value;
    const newAssetTransactionType = this.formControlStep2TransactionType.value;
    if (newAssetConditionValue?.type === 'New' && !isTransactionTypeAllowedForNewAsset(newAssetTransactionType?.type)) {
      const allowedTransactionTypes = getAllowedTransactionTypesForNewAsset(this.isInternalUser);
      this.applicationDialogService.openAlertDialog({
        message: `Validation Error`,
        subMessage: `A "New" asset can only have a Transaction Type of ${allowedTransactionTypes.map(t => `"${t}"`).join(' or ')}. Please update the Transaction Type or Asset Condition.`
      });
      return;
    }

    // validation of credit adjustment
    const applicationCreditAdjustment = applicationToCrediRateAdjustment(this.application);
    const currentCreditAdjustment = this.formControlCreditRateAdjustment.value!;
    if (applicationCreditAdjustment != currentCreditAdjustment) {
      if (this.isAdmin) {
        if (currentCreditAdjustment < this.ADMIN_MIN_CREDIT_RATE || currentCreditAdjustment > this.ADMIN_MAX_CREDIT_RATE) {
          this.applicationDialogService.openAlertDialog({
            message: `Credit Adjustment`,
            subMessage: `Credit adjustment needs to be between ${this.ADMIN_MIN_CREDIT_RATE} and ${this.ADMIN_MAX_CREDIT_RATE}`,
          });
          return;
        }
      } else if (this.isCreditUser) {
        if (currentCreditAdjustment < this.CREDIT_MIN_CREDIT_RATE || currentCreditAdjustment > this.CREDIT_MAX_CREDIT_RATE) {
          this.applicationDialogService.openAlertDialog({
            message: `Credit Adjustment`,
            subMessage: `Credit adjustment needs to be between ${this.CREDIT_MIN_CREDIT_RATE} and ${this.CREDIT_MAX_CREDIT_RATE}`,
          });
          return;
        }
      } else { // not admin or credit
        if (currentCreditAdjustment < this.NON_CREDIT_OR_ADMIN_MIN_CREDIT_RATE || currentCreditAdjustment > this.NON_CREDIT_OR_ADMIN_MAX_CREDIT_RATE) {
          this.applicationDialogService.openAlertDialog({
            message: `Credit Adjustment`,
            subMessage: `Credit adjustment needs to be between ${this.NON_CREDIT_OR_ADMIN_MIN_CREDIT_RATE} and ${this.NON_CREDIT_OR_ADMIN_MAX_CREDIT_RATE}`,
          });
          return;
        }
      }
    }

    this.openPricingComparisonAndSave();
  }

  private openPricingComparisonAndSave() {
    this.step2EstimatedDrawdownDate = moment().add(1, 'day');
    const date = moment();
    const newValue = this.calculateEstimation(date);
    this.subscriptions.push(this.applicationDialogService.openAssetPricingComparisonDialog({
      currentValue: this.currentRstValue ?? newValue,
      newValue: newValue
    }).afterClosed()
      .pipe(
        tap(r => {
          if (r && r.acceptedQuotation) {
            // update the doc fee
            this.terms!.docFee = r.docFee;
            // patch current rst docfee, save will emit events that asset-finance-application-details component subscribe
            this.rst!.totalPaymentBreakupDialogData.paymentChartData.docFee = r.docFee;
            // recreate application data for submission
            this.data = this.createApplicationData();
            this.save();
          }
        })
      ).subscribe());
  }

  private isBalloonPercentageDecreased(): boolean {
    const originalBalloonPercentage = applicationToBalloonPaymentPrecentageNumber(this.application) ?? 0;
    const currentBalloonPercentage = Number(this.formControlStep2BalloonPayment.value?.type ?? 0);
    return currentBalloonPercentage < originalBalloonPercentage;
  }

  calculateEstimation(date: Moment): TotalPaymentBreakupDialogData {
    const paymentFrequencyValue: PaymentFrequencyValue = this.formControlStep2PaymentFrequency.value;
    const assetConditionValue: AssetConditionValue = this.formControlStep2AssetCondition.value;
    const assetSelectionValue: AssetSelectionComponentValue = this.formControlStep2Asset.value;
    const loanTermValue: LoanTermsSelectionWithInputValue = this.formControlStep2LoanTerms.value;
    const financeTypeValue: FinanceTypeValue = this.formControlStep2FinanceType.value;
    const balloonPaymentValue: BalloonPaymentValue = this.formControlStep2BalloonPayment.value;
    const loanAmount = _.round(this.formControlStep2LoanAmount.value ?? 0, 2);
    const brokerageAmount = this.formControlStep2BrokerageAmount.value;
    const brokeragePercentage = Math.round((brokerageAmount ?? 0) * 10000 / loanAmount) / 100;
    const brokerageValue: BrokerageSelectionValue = {type: `${brokeragePercentage}` as BrokerageSelectionType, name: `${brokeragePercentage}%`};
    const balloonPaymentPercentage = numeral(balloonPaymentValue?.type).value() ?? 0;
    const creditRateAdjustment = this.formControlCreditRateAdjustment.value;
    const businessSearchValue = applicationToBusinessSearchValue(this.application);
    
    // Calculate ABN age threshold override: only set when user has changed from original
    const abnAgeAboveThresholdOverride = this.getAbnAgeAboveThresholdOverride();
    
    this.rst = calculateAssetFinanceEstimation(date, {
      type: 'AssetFinance',
      paymentFrequencyType: paymentFrequencyValue?.type ?? null,
      assetConditionType: assetConditionValue?.type ?? null,
      assetSelectionValue: assetSelectionValue!,
      assetYear: parseFloat(assetSelectionValue?.year ?? '0'),
      loanTerm:  numeral(loanTermValue).value() ?? 0,
      financeType: financeTypeValue?.type ?? null,
      loanAmount: numeral(this.formControlStep2LoanAmount.value).value() ?? 0,
      propertyOwnership: this.formControlStep2PropertyOwner.value ?? false,
      docFeeFinanced: this.formControlStep2DocFeeFinanced.value ?? false,
      brokerOriginationFee: this.formControlStep2BrokerOriginationFee.value ?? 0,
      brokerage: Number(brokerageValue?.type ?? 0),
      brokerageAmount: brokerageAmount ?? 0,
      adverseOnFile: this.formControlStep2AdverseOnFile.value ?? false,
      equifaxDirectorScoreMeetsProductThreshold: this.formControlStep2EquifaxScoreAboveThreshold.value ?? false,
      equifaxDirectorScoreAbove700: this.formControlStep2EquifaxDirectorScoreAbove700.value ?? false,
      privateSaleOrLeaseback: this.formControlStep2TransactionType.value?.type !== 'Dealer Sale',
      //balloonPayment: numeral(balloonPaymentValue).value() ?? 0,
      balloonPayment: balloonPaymentPercentage,
      repaymentType : getRepaymentType(this.application) ?? '',
      rateCard: this.rateCard,
      invoiceAmount: this.formControlStep2InvoiceAmount.value ?? 0,
      deposit: this.formControlStep2DepositAmount.value ?? 0,
      transactionType: this.formControlStep2TransactionType.value?.type,

      // extra fields that affects estimation
      creditRateAdjustment: creditRateAdjustment ?? 0,
      businessSearchValue: (businessSearchValue?.type === 'search-result' ? businessSearchValue : null),
      existingApplicationBureauReport: this.application.CompanyDetails ?? null,
      abnAgeAboveThresholdOverride,
    });

    this.calculator = this.rst.calculator;
    this.terms = this.rst.terms;
    this.step2Repayment = this.rst.repayment;
    this.AmountFinance = (this.rst.calculator.principalAmt + this.rst.calculator.brokerageAmount);

    console.log('****** calc result', this.rst);
    this.data = this.createApplicationData();

    return this.rst.totalPaymentBreakupDialogData;
  }

  // Maximum balloon/residual percentage allowed so the balloon amount does not
  // exceed the loan amount (Invoice - Deposit). Returns 100 (no constraint) when
  // the invoice amount is not yet known.
  step2GetLoanAmountMaxBalloonPercentage(): number {
    const invoiceAmount = this.formControlStep2InvoiceAmount.value ?? 0;
    const depositAmount = this.formControlStep2DepositAmount.value ?? 0;
    if (invoiceAmount <= 0) {
      return 100;
    }
    const loanAmount = Math.max(invoiceAmount - depositAmount, 0);
    return Math.floor(loanAmount / invoiceAmount * 100);
  }

  // Recompute the max selectable balloon/residual %. Balloon/residual is not allowed
  // for Rental or loan terms > 60 months; otherwise it is capped at 50% and further
  // capped so the balloon amount never exceeds the loan amount (Invoice - Deposit).
  step2UpdateMaxBalloonPercentage() {
    const isRental = this.formControlStep2FinanceType.value?.type === 'rental';
    const loanTerm = this.formControlStep2LoanTerms.value;
    const isLongTerm = loanTerm && loanTerm > 60;
    if (isRental || isLongTerm) {
      this.step2MaxBalloonPercentage = 0;
      this.formControlStep2BalloonPayment.setValue(BalloonPaymentValueOptions[0]);
      this.formControlStep2BalloonPayment.disable();
    } else {
      this.formControlStep2BalloonPayment.enable();
      this.step2MaxBalloonPercentage = Math.min(50, this.step2GetLoanAmountMaxBalloonPercentage());
    }
  }

  step2UpdateDepositValidation() {
    const asset: AssetSelectionComponentValue = this.formControlStep2Asset.value;
    if (asset && !asset.invalid) {
      const invoiceAmount = this.formControlStep2InvoiceAmount.value ?? 0;
      const assetCategoryIndex = asset.category.index;
      const isPropetyOwner = this.formControlStep2PropertyOwner.value ?? false;

      const productType = (this.application.ApplicationType == "AssetFinance" ? this.application.AppInfo.productType : undefined);
      const minDeposit = minDepositForPricingAssetFinance(this.isAdminOrCreditUser, invoiceAmount, assetCategoryIndex, isPropetyOwner, productType);
      this.step2DepositMin = minDeposit;
      this.step2DepositMax = _.round(invoiceAmount - 2000 < 0 ? invoiceAmount : invoiceAmount - 2000, 2); // $2000 minimum loan amount;
    }
  }

  onAssetSelectionEvent($event: AssetSelectionComponentEvent) {
    this.assetSelectionReady = ($event.type == 'loaded');
  }

  canGenerateQuote(): boolean {
    const canGenerate = (
      this.canEditPricingByRole && this.formGroupStep2.valid && !this.formControlStep2Asset.value?.invalid &&
      (!this.isApplicationStagePostQa) && (!this.isContractPending)
    );
    if (!canGenerate) {
      this.markSubject.next(true);
    }
    return canGenerate;
  }

  canEditPricing(): boolean {
    if(this.isDealer && DEALER_SALE_TRANSACTION_TYPE){
      this.formControlStep2TransactionType.disable();
      this.formControlStep2TransactionType.setValue({...DEALER_SALE_TRANSACTION_TYPE })
    }
    return (
      this.canEditPricingByRole &&
      (!this.isApplicationStagePostQa) && (!this.isContractPending)
    );
  }

  onEditBrokerage() {
    this.subscriptions.push(
      this.applicationDialogService.openEditBrokerageDailog({
        brokerageAmount: this.formControlStep2BrokerageAmount.value ?? 0,
        loanAmount: this.formControlStep2LoanAmount.value ?? 0,
        maxBrokeragePercentage: ASSET_FINANCE_MAX_BROKERAGE_PERCENT,
        warningBrokeragePercentage: ASSET_FINANCE_BROKERAGE_UPLIFT_TIER1_PERCENT,
      }).afterClosed().subscribe(result => {
        if (result && result?.readyForSubmission) {
          this.formControlStep2BrokerageAmount.setValue(result.brokerageAmount);
          this.brokeragePercentage = result.brokeragePercentage;

          console.log(this.brokeragePercentage, _.round((this.formControlStep2BrokerageAmount.value ?? 0) * 100 / (this.formControlStep2LoanAmount.value ?? 0), 2))
        }
      })
    )
  }

  onEditInvoiceAmount() {
    console.log( "minDeposit: ", this.step2DepositMin)
    console.log( "maxDeposit: ", this.step2DepositMax)

    this.subscriptions.push(
      this.applicationDialogService.openEditInvoiceAmountDailog({
        title: this.formControlStep2FinanceType.value?.type === 'rental' ? 'Edit Asset finance amount (ex GST)' : 'Edit Asset finance amount (incl GST)',
        invoiceAmount: this.formControlStep2InvoiceAmount.value ?? 0,
        depositAmount: this.formControlStep2DepositAmount.value ?? 0,
        min: this.step2InvoiceAmountMin,
        originalLoanAmount: applicationToLoanAmount(this.application) ?? 0,
        limitMaxInvoiceAmount: this.isNotAdminOrCreditUser,
        minDeposit: this.step2DepositMin,
        maxDeposit: this.step2DepositMax,
        isPropetyOwner: this.formControlStep2PropertyOwner.value ?? false,
        assetCategoryIndex: this.formControlStep2Asset.value?.category.index ?? '',
        financeType: this.formControlStep2FinanceType.value?.type ?? 'chattel-mortgage',
        isConsumer: false,
        isCreditOrAdmin: this.isAdminOrCreditUser,
        productType: this.application.AppInfo.productType,
      }).afterClosed().subscribe(result => {
        console.log('===result: ', result)
        if (result && result?.readyForSubmission) {
          this.formControlStep2InvoiceAmount.setValue(result.invoiceAmount);
          this.formControlStep2DepositAmount.setValue(result.depositAmount);
        }
      })
    )
  }
}
